import { MandantDto } from '../dtos/mandant.dto';
import { MandantModel } from '../models/mandant.model';

export function mapMandatDtoToMandantModel(
  mandantDto: MandantDto
): MandantModel {
  return {
    id: mandantDto.id,
    name: mandantDto.name,
    logo: mandantDto.logo,
  };
}
